import moment from 'moment-timezone';

export default function setDefaultTimezone(timezoneValue) {
  moment.tz.setDefault(timezoneValue);
}
